import React, { FC } from "react";
import VODAdminLayout from "../../../layouts/admin/VODAdminLayout";
import VODStandaloneContentListingView from "./components/assets/VODStandaloneContentListingView";
import VODSeriesContentGroupListingView from "./components/assets/VODSeriesContentGroupListingView";
import { NavLink, useParams } from "react-router";

const VODAssetView: FC = () => {

    const { assetType } = useParams();

    const tabButtonStyle = (isSelected: boolean) => {
        return "flex items-center cursor-default rounded-full px-4 py-1.5 text-sm font-medium transition forced-color-adjust-none " +
            (isSelected
               ? "text-white dark:text-white forced-colors:text-[HighlightText] bg-gray-800 dark:bg-gray-800 forced-colors:bg-[Highlight]"
               : `text-gray-600 dark:text-gray-300 hover:text-gray-700 pressed:text-gray-700 dark:hover:text-gray-200 dark:pressed:text-gray-200 
                  hover:bg-gray-300 dark:hover:bg-gray-600 pressed:bg-gray-300 dark:pressed:bg-gray-600`);

    };

    return (
        <>
            <VODAdminLayout heading="VOD Assets">
                <div className="h-full flex flex-col mr-6">
                    <div className="flex flex-row gap-4">
                        <NavLink
                            to="/dashboard/vod/assets/standalone-content"
                            className={tabButtonStyle(assetType === "standalone-content")}
                        >
                            Standalone
                        </NavLink>
                        <NavLink
                            to="/dashboard/vod/assets/series-content-group"
                            className={tabButtonStyle(assetType === "series-content-group")}
                        >
                            Series
                        </NavLink>
                    </div>
                    <div className="flex flex-col flex-shrink flex-grow min-h-0">
                        {assetType === "standalone-content" && <VODStandaloneContentListingView />}
                        {assetType === "series-content-group" && <VODSeriesContentGroupListingView />}
                    </div>
                </div>
            </VODAdminLayout>
        </>
    );
};

export default VODAssetView;